$(".site-menu-main").bind("click", function () {
  var open = $(this).parent().hasClass("open");

  if (!open) {
    $(".site-menu-item.main").not($(this).parent()).removeClass("open");

    $(".ul-sub").not($(this).next()).hide(300);

    $(this).next().show(300);

    $(this).parent().addClass("open");
  } else {
    $(this).next().hide(300);

    $(this).removeClass("active");

    $(this).parent().removeClass("open");
  }
});

$(".site-menu-item.nav").bind("click", function () {
  var id = $(this).attr("id");

  if (typeof id !== "undefined") {
    $(this).parent().parent().addClass("active");

    sessionStorage.setItem("site-menu-item", id);
  }
});

$(function () {
  var id = document.location.pathname;

  var item = $('[url= "' + id + '"]');

  if (item.length == 0) {
    if (id.includes("education")) {
      id = "/education";
    } else if (id.includes("promo")) {
      id = "/promo";
    } else if (id.includes("module")) {
      id = "/module";
    } else if (id.includes("accounts")) {
      id = "/documents";
    } else if (id.includes("learncontrol") && document.location.search.includes("[internal]=1")) {
      id = "/q/learncontrol/all_persons_stat?externvar[internal]=1";
    } else if (id.includes("learncontrol") && document.location.search.includes("[internal]=0")) {
      id = "/q/learncontrol/all_persons_stat?externvar[internal]=0";
    } else if (id.includes("exam")) {
      id = "/tests";
    } else if (id.includes("certifications") && (id.includes("external_persons") || id.includes("external_requests") || id.includes("digital_protocols") || id.includes("statistics4certificstions") || id.includes("protocol_analytics") )) {
      id = "/q/certifications/external_courses";
    } else if (id.includes("certifications")) {
      id = "/certifications";
    } else if ((id.includes("q/groups") || id.includes("q/alerts") || id.includes("q/users")) && document.location.search.includes("[internal]=0")) {
      id = "/q/alerts/groups?externvar[internal]=0";
    } else if ((id.includes("q/groups") || id.includes("q/alerts")) && document.location.search.includes("[internal]=1")) {
      id = "/q/alerts/users?externvar[internal]=1";
    } else if (id.includes("training")) {
      id = "/education";
    } else if (id.includes("knowledge")) {
      id = "/q/kbviewer/kb";
    } else if (id.includes("journal_people_schedule")) {
      id = "/q/edu4/protocol_date_schedule";
    } else if (id.includes("edu4/comis") || id.includes("edu4/journal")) {
      id = "/q/edu4/protocol";
    } else if (id.includes("edu4/courses") || id.includes("edu4/areas")) {
      id = "/q/edu4/rules";
    } else if (id.includes("documents")) {
      id = "documents";
    } else if (id.includes("/rms/dic")) {
      id = "/q/rms/dic/risk_zones";
    } else if (id.includes("/haccp/auditors")) {
      id = "/q/haccp/control";
    } else if (id.includes("/haccp/tasks_history")) {
      id = "/q/haccp/monitoring";
    } else if (id.includes("/haccp/auditors")) {
      id = "/q/haccp/control";
    } else if (id.includes("instruction") && id.includes("topic")) {
      id = "/instruction";
    } else if (id.includes("instruction_journal4persons")) {
      id = "/q/instructions/instruction_journal";
    } else if (
      id.includes("/regular/dangers") ||
      id.includes("/regular/dangers/situations") ||
      id.includes("/regular/ppe/groups") ||
      id.includes("/regular/ppe")
    ) {
      id = "/q/rms/regular/documents";
    } else {
      var id = "/" + sessionStorage.getItem("site-menu-item");
    }
  }

  $(".site-menu-item").removeClass("active");

  $('[url= "' + id + '"]')
    .parent()
    .parent()
    .addClass("open");

  $('[url= "' + id + '"]')
    .parent()
    .removeClass("sub");

  $('[url= "' + id + '"]').addClass("active");

  $('[url= "' + id + '"]')
    .parent()
    .parent()
    .addClass("active");
});
